import { c as _c } from "react/compiler-runtime";
import React from "react";
interface BorderInputBoxProps {
  type: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  border: {
    color: string;
    borderWidth: string;
    radius: string;
  };
  className?: string;
  style?: React.CSSProperties;
  autoComplete?: string;
}
const BorderInputBox = t0 => {
  const $ = _c(15);
  const {
    type,
    placeholder,
    value,
    onChange,
    border: t1,
    className,
    style,
    autoComplete
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {
      color: "#0F0F10",
      borderWidth: "1px",
      radius: "8px"
    } : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const border = t2;
  const t3 = `${className}`;
  let t4;
  if ($[2] !== border.borderWidth || $[3] !== border.color || $[4] !== border.radius || $[5] !== style) {
    t4 = {
      borderColor: border.color,
      borderWidth: border.borderWidth,
      borderRadius: border.radius,
      ...style
    };
    $[2] = border.borderWidth;
    $[3] = border.color;
    $[4] = border.radius;
    $[5] = style;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== autoComplete || $[8] !== onChange || $[9] !== placeholder || $[10] !== t3 || $[11] !== t4 || $[12] !== type || $[13] !== value) {
    t5 = <input type={type} value={value} onChange={onChange} className={t3} placeholder={placeholder} autoComplete={autoComplete} style={t4} />;
    $[7] = autoComplete;
    $[8] = onChange;
    $[9] = placeholder;
    $[10] = t3;
    $[11] = t4;
    $[12] = type;
    $[13] = value;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export default BorderInputBox;